import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "form-wrapper slide-up" }
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { style: {"margin-bottom":"20px","max-height":"300px","overflow":"auto"} }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("h3", null, "Select Attendees", -1)),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.localEmployees.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "No employees to select."))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localEmployees, (emp, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "checkbox-input"
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": ($event: any) => ((emp.selected) = $event)
            }, null, 8, _hoisted_6), [
              [_vModelCheckbox, emp.selected]
            ]),
            _createElementVNode("div", null, _toDisplayString(emp.Name), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("input", {
        type: "submit",
        value: _ctx.submitLabel || 'Save',
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save()))
      }, null, 8, _hoisted_7)
    ])
  ]))
}